module.exports = __webpack_public_path__ + "dcf0bb6debb08da1fffd6c7ed1d5ed08.pdf";